import React from 'react'
import {Select} from '../../../../shared/Select'

export function SelectField({
  field,
  values,
  value,
  variant,
  size,
  disabled,
  error,
  touched,

  onBlur = () => {},
  onChange,
}) {
  const normalizedOptions = field.options?.map(option => ({
    label: option.label || option.name,
    value: option.value || option.code,
  }))

  return (
    <Select
      label={
        typeof field.label === 'function' ? field.label(values) : field.label
      }
      placeholder="Select"
      value={value}
      variant={variant}
      size={size}
      disabled={disabled}
      labelLeftIcon={field.labelLeftIcon}
      options={normalizedOptions}
      errorText={error}
      helperText={field.helperText}
      required={field.validators?.includes('required')}
      onChange={e => onChange(field.key, e.target.value)}
      onBlur={() => onBlur(field.key)}
    />
  )
}
